<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>
    <app-offcanvas-header-btn title="Add employee"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    <app-employee-form class="offcanvas-body-inner" />
  </ng-container>
</app-offcanvas-base>
